import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function MarkerPinIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M8 8.6c1.036 0 1.875-.806 1.875-1.8S9.035 5 8 5s-1.875.806-1.875 1.8S6.965 8.6 8 8.6" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M8 14c2.5-2.4 5-4.549 5-7.2S10.761 2 8 2 3 4.149 3 6.8s2.5 4.8 5 7.2" /></svg>
  );
}

export default MarkerPinIcon;
